<template>
    <div>
        <div class="pageheader pd-t-25 pd-b-15">
            <div class="pd-t-5 pd-b-5">
                <h1 class="pd-0 mg-0 tx-20 text-overflow">Transaksi Masuk</h1>
            </div>
            <div class="breadcrumb pd-0 mg-0">
                <a class="breadcrumb-item" href="#"><i class="fa fa-check-square-o mg-r-5"></i>Transaksi Masuk</a>
                <a class="breadcrumb-item" >
                    <router-link :to="{ name:'transaksi.simasket'}">
                    Simasket
                    </router-link>
                </a>
                <span class="breadcrumb-item active"> Detail</span>
            </div>
        </div>

        <!-- MAIN CONTENT ================================================== -->
        <div class="row justify-content-center">
            <div class="col-sm-5">
                <div class="card">
                    <div class="card-header">
                        <h5 class="card-header-title">
                            Informasi Dokumen
                        </h5>
                        <span class="badge badge-info">Dari SIMASKET</span>
                    </div>
                    <div class="card-body">
                        <div class="alert alert-info" role="alert">
                            <i class="fa fa-lock mg-r-5"></i>
                            Transaksi ini dikirim dari SIMASKET dan tidak bisa diubah atau dihapus di e-Persediaan.
                        </div>
                        <table class="table table-sm table-borderless mb-0">
                            <tbody>
                                <tr><td style="width:40%">No Dokumen</td><td>: {{ form.no_dokumen }}</td></tr>
                                <tr><td>No Bukti/BAST</td><td>: {{ form.no_bukti }}</td></tr>
                                <tr><td>Tanggal Dokumen</td><td>: {{ form.tgl_dokumen }}</td></tr>
                                <tr><td>Tanggal Buku</td><td>: {{ form.tgl_buku }}</td></tr>
                                <tr><td>Jenis Pencairan</td><td>: {{ form.pencairan }}</td></tr>
                                <tr><td>Jenis Anggaran</td><td>: {{ form.anggaran }}</td></tr>
                                <tr><td>Penyedia/Pemberi</td><td>: {{ form.sumber }}</td></tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-sm-7">

                <!-- CONTENT -->
                <div class="tab-content mb-3">
                    <div class="tab-pane show active" id="anggota-tab" role="tabpanel">
                        <div class="card">
                            <div class="card-header">
                                <div class="input-group input-group-flush input-group-merge">
                                    <input type="search" class="form-control form-control-prepended search" v-model="keywords" v-on:keyup.enter="getData()" placeholder="Cari Item...">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text">
                                            <span class="fe fe-search"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="table-responsive">
                                <table class="m-2 table table-sm table-striped  table-responsive-sm">
                                    <thead>
                                        <tr>
                                            <th style="width:4%">No</th>
                                            <th>Kode Barang</th>
                                            <th>Nama Barang</th>
                                            <th>Satuan</th>
                                            <th>Jumlah</th>
                                            <th>Harga Satuan</th>
                                            <th>Total</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="dataItem.length == 0">
                                        <tr>
                                            <td colspan="7">
                                                <div class="alert alert-danger text-center" role="alert">
                                                    Belum Ada Data
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody>
                                        <tr v-for="(item, index) in dataItem" :key="index">
                                            <td>{{ (index + 1) + (pagination.currentPage - 1) * pagination.limit }}</td>
                                            <td>{{ item.code }}</td>
                                            <td>
                                                <div style="width:200px;white-space: normal;">
                                                {{ item.name }}
                                                </div>
                                            </td>
                                            <td>{{ item.satuan }}</td>
                                            <td>{{ item.jumlah }}</td>
                                            <td>{{ item.harga | VMask(currencyMask) }}</td>
                                            <td>{{ item.total | VMask(currencyMask) }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="card-footer border-top-0">
                                <div style="float:right">
                                    <v-pagination v-if="pagination.totalPages > 0" v-model="pagination.currentPage"
                                                :page-count="pagination.totalPages"
                                                :classes="pagination.bootstrapPaginationClasses"
                                                :labels="pagination.paginationAnchorTexts"
                                                v-on:change="getData()"></v-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br>
        <!-- END MAIN CONTENT -->
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import vPagination from 'vue-plain-pagination'
    import Vue from 'vue'
    import VueMask from 'v-mask'
    Vue.use(VueMask);

    import createNumberMask from 'text-mask-addons/dist/createNumberMask';
    const currencyMask = createNumberMask({
        prefix: '',
        allowDecimal: true,
        decimalLimit: 7,
        includeThousandsSeparator: true,
        allowNegative: false,
    });

    export default {
        metaInfo: {
            title: 'SI',
            titleTemplate: '%s - Data Persediaan'
        },
        data() {
            return {
                baseUrl: this.$apiconfig,
                currencyMask,
                dataItem: [],
                fetching: true,
                form: {
                    id: this.$route.params.id ? this.$route.params.id : '',
                    no_bukti: '',
                    no_dokumen: '',
                    tgl_dokumen: '',
                    tgl_buku: '',
                    sumber: '',
                    status: '',
                    pencairan: '',
                    anggaran: '',
                },
                pagination: {
                    currentPage: 1,
                    totalPages: 0,
                    limit: 10,
                    bootstrapPaginationClasses: {
                        ul: 'pagination',
                        li: 'page-item',
                        liActive: 'active',
                        liDisable: 'disabled',
                        button: 'page-link'
                    },
                    paginationAnchorTexts: {
                        first: '<i class="fe fe-chevrons-left"></i>',
                        prev: '<i class="fe fe-chevron-left"></i>',
                        next: '<i class="fe fe-chevron-right"></i>',
                        last: '<i class="fe fe-chevrons-right"></i>'
                    }
                },
                keywords: '',
            }
        },
        computed: mapState(['userdata']),
        created() {
            this.$store.dispatch('loadUserData');
            this.loadData();
            this.getData();
        },
        components: {
            vPagination,
        },
        methods: {
            loadData() {
                this.$http.get(this.baseUrl + 'transaksi/masuk/form', {
                    params: {
                        idTransaksi: this.form.id,
                    }
                })
                    .then((response) => {
                        let data = response.data.data[0];
                        // Hanya transaksi kiriman SIMASKET yang boleh dibuka di halaman ini
                        if(!data || data.status != 'simasket'){
                            this.$router.push({ name: 'transaksi.simasket' });
                            return;
                        }
                        this.form.no_dokumen = data.no_dokumen;
                        this.form.no_bukti = data.no_bukti;
                        this.form.tgl_dokumen = data.tgl_dokumen;
                        this.form.tgl_buku = data.tgl_buku;
                        this.form.pencairan = data.pencairan;
                        this.form.anggaran = data.anggaran;
                        this.form.sumber = data.sumber;
                        this.form.status = data.status;
                    })
                    .catch((error) => {
                        console.log(error.response.data);
                    });
            },
            getData() {
                this.fetching = true;
                this.$http.get(this.baseUrl + 'transaksi/masuk/item', {
                    params: {
                        page : this.pagination.currentPage,
                        keywords: this.keywords,
                        idTransaksi: this.form.id,
                    }
                })
                    .then((response) => {
                        this.dataItem = response.data.data;
                        this.fetching = false;
                        this.pagination.totalPages = response.data.total_page;
                    })
                    .catch((error) => {
                        console.log(error.response.data);
                        this.fetching = false;
                    });
            },
        },
    };
</script>
